import type { CarouselCardProps } from '@chegg-wt/core/components/ProofReader/CardImageCarousel/CarouselCard'
import { AIPoweredBadge } from '@chegg-wt/core/components/ProofReader/CardImageCarousel/AIPoweredBadge'
import { BadgeHeading } from './styled'

export type CarouselCardWithImage = Omit<CarouselCardProps, 'isActive'> & {
  carouselImage: string
}

export const getCarouselCardsWithImage = ({
  writingAssistantRoute,
  plagiarismRoute,
  createCitationRoute,
}): CarouselCardWithImage[] => [
  {
    heading: (
      <BadgeHeading>
        Enhance your writing <AIPoweredBadge />
      </BadgeHeading>
    ),
    content:
      'Get instant grammar suggestions, plus tools to shorten, expand, or paraphrase.',
    actionButtonRoute: writingAssistantRoute,
    actionButtonText: 'Get started',
    dataTestId: 'polish-writing',
    carouselImage: 'polish-writing.webp',
  },
  {
    heading: 'Cite your sources',
    content:
      'Cite any source using MLA, APA, Chicago, Harvard, and thousands more styles.',
    actionButtonRoute: createCitationRoute,
    actionButtonText: 'Create citations',
    dataTestId: 'generate-citations',
    carouselImage: 'generate-citations.webp',
  },
  {
    heading: 'Check for plagiarism',
    content: 'Scan your paper for unintentional plagiarism against billions of sources.',
    actionButtonRoute: plagiarismRoute,
    actionButtonText: 'Scan my paper',
    dataTestId: 'check-for-plagiarism',
    carouselImage: 'check-for-plagiarism.webp',
  },
]
